import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import {Button} from 'react-bootstrap';
import axios from 'axios';
import ContractResearchCompletedModal from "./ContractResearchCompletedModal";

export default class ContractResearchCompleted extends Component {
    constructor() {
        super();

        this.state = {
            research_completed_at: null,
            show_modal: false
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillMount() {
        this.getData();
    }

    getData() {
        axios
            .get("/contracts/ajax/manage_contracts/" + this.props.contractId + "/research_completed")
            .then((response) => {
                this.setState({research_completed_at: response.data});
            });
    }

    openModal() {
        this.setState({show_modal: true});
    }

    closeModal() {
        this.setState({show_modal: false}, () => {
            this.getData();
        });
    }

    render() {
        let alert = null;
        if (this.state.research_completed_at === null) {
            alert = (
                <div className="alert alert-warning" role="alert">
                    {window.__js_contracts.research_not_completed}
                </div>
            );
        }
        else {
            alert = (
                <div className="alert alert-success" role="alert">
                    {window.__js_contracts.research_completed_at} <strong>{this.state.research_completed_at}</strong>.
                </div>
            );
        }

        let modal = null;
        if (!this.props.readonly) {
            modal = (
                <ContractResearchCompletedModal
                    contractId={this.props.contractId}
                    showModal={this.state.show_modal}
                    closeCallback={this.closeModal}/>
            );
        }

        return (
            <div>
                {alert}
                <Button onClick={this.openModal}
                        bsStyle="primary"
                        className={this.props.readonly ? "hidden" : ""}>
                    <i className="fa fa-pencil"></i> {window.__js_general.change}
                </Button>
                {modal}
            </div>
        );
    }
}

if (document.getElementById("contract-research-completed")) {
    let element = document.getElementById("contract-research-completed");
    let csrf_token = element.getAttribute("data-csrf-token");
    let contract_id = element.getAttribute("data-contract-id");
    let readonly = (element.getAttribute("data-readonly") === "1");

    ReactDOM.render(
        <ContractResearchCompleted
            csrfToken={csrf_token}
            contractId={contract_id}
            readonly={readonly}/>,
        element
    );
}